import axios from '../axios'
// 预警类型  strategy_type_list
export const warntype = (data) => {
  return axios({
    url: '/admin/service/strategy_type_list',
    method: 'post',
    data
  })
}

// 预警列表
export const strategy_list = (data) => {
  return axios({
    url: '/admin/service/strategy_list',
    method: 'post',
    data
  })
}

//黑名单预警触发日志列表
// export const blacklist = (data) => {
//     return axios({
//         url: '/admin/service/blacklist_log_list',
//         method: 'post',
//         data
//     })
// }

//添加人员到预警
export const savewarn = (data) => {
  return axios({
    url: '/admin/service/strategy_save',
    method: 'post',
    data
  })
}

// 删除预警人员
export const deletewarn = (data) => {
  return axios({
    url: '/admin/service/strategy_del',
    method: 'post',
    data
  })
}

// 预警消息列表
export const strategy_log_list = (data) => {
  return axios({
    url: '/admin/service/strategy_log_list',
    method: 'post',
    data
  })
}
// 预警人员列表
// admin/service/sys_personWarning_list
export const personWarning_list = (data) => {
  return axios({
    url: '/admin/service/sys_personWarning_list',
    method: 'post',
    data
  })
}
// 境外人员预警
// admin/service/sys_personWarning_list
export const sys_pass_border = (data) => {
  return axios({
    url: '/admin/service/sys_pass_border',
    method: 'post',
    data
  })
}
// 境外人员预警状态修改
export const sys_pass_borderupdate = (data) => {
  return axios({
    url: '/admin/service/sys_pass_borderupdate',
    method: 'post',
    data
  })
}


// 境外预警设置

export const passBorder_configure = (data) => {
  return axios({
    url: '/admin/service/sys_passBorder_configure',
    method: 'post',
    data
  })
}

// 预警设置
// sys_passBorder_list
export const passBorder_list = (data) => {
  return axios({
    url: '/admin/service/sys_passBorder_list',
    method: 'post',
    data
  })
}
// sys_passBorder_remove   PCID
export const passBorder_remove = (data) => {
  return axios({
    url: '/admin/service/sys_passBorder_remove',
    method: 'post',
    data
  })
}
// 新增人员预警类型
// 
export const dictionaries_add = (data) => {
  return axios({
    url: '/admin/service/sys_dictionaries_add',
    method: 'post',
    data
  })
}
// 预警管理列表
export const sys_dictionaries_list = (data) => {
  return axios({
    url: '/admin/service/sys_dictionaries_list',
    method: 'post',
    data
  })
}
// 删除类型

export const dictionaries_remove = (data) => {
  return axios({
    url: '/admin/service/sys_dictionaries_remove',
    method: 'post',
    data
  })
}

// 
export const dictionaries_array = (data) => {
  return axios({
    url: '/admin/service/sys_dictionaries_array',
    method: 'post',
    data
  })
}
// 
export const event_array = (data) => {
    return axios({
      url: '/admin/service/sys_event_array',
      method: 'post',
      data
    })
  }
  // 操作标记为已读
export const sys_strategy_read = (data) => {
  return axios({
    url: '/admin/service/sys_strategy_read',
    method: 'post',
    data
  })
}
 // 操作标记为已读
 export const sys_get_total = (data) => {
  return axios({
    url: '/admin/service/sys_get_total',
    method: 'post',
    data
  })
}
//报警铃声
export const sys_check_warning = (data) => {
  return axios({
    url: '/admin/service/sys_check_warning',
    method: 'post',
    data,
    type:2
  })
}
// 账号到期修改列表
export const account_charge_list = (data) => {
  return axios({
    url: '/admin/service/account_charge_list',
    method: 'post',
    data,
  })
}
// 获取服务器时间
export const getCurrentTime = (data) => {
  return axios({
    url: '/admin/service/getCurrentTime',
    method: 'post',
    data,
  })
}
// 更新服务期限
export const account_charge_update = (data) => {
  return axios({
    url: '/admin/service/account_charge_update',
    method: 'post',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/warn.js